import React from "react";

export const KitchenPlate: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="111" height="72" viewBox="0 0 111 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="61.1998" cy="39.5999" r="32.04" fill="#E8ECEF" stroke="currentColor" strokeWidth="0.72"/>
<circle cx="61.2001" cy="39.6001" r="21.6" fill="currentColor"/>
<path d="M23.0538 25.2H17.2903V0H11.5269V25.2H5.76344V0H0V25.2C0 33.156 5.15828 39.6 11.5269 39.6V72H17.2903V39.6C23.6589 39.6 28.8172 33.156 28.8172 25.2V0H23.0538V25.2Z" fill="currentColor"/>
<rect x="11.52" y="41.76" width="5.76" height="25.92" fill="#E8ECEF"/>
<path d="M96.4795 14.4V43.2H105.125V72H110.888V0C102.935 0 96.4795 8.064 96.4795 14.4Z" fill="currentColor"/>
<rect x="105.12" y="46.0801" width="5.76" height="22.32" fill="#E8ECEF"/>
</svg>
);
